module.exports = __webpack_public_path__ + "static/media/win-friends.7b910c9b.jpg";